import { Card, CardContent, Typography, Box } from '@mui/material';
import QuestionnaireAnswersTable from '../../QuestionnaireBuilder/QuestionnaireAnswersTable';
import { t } from 'i18next';

export default function AnsweredQuestionnaires({
    questionnaireAnswers,
    qaLoading,
    qaTotalCount,
    qaPaginationModel,
    setQaPaginationModel,
    qaRowsPerPageOptions
}) {
    return (
        <Card sx={{ mb: 3 }}>
            <CardContent sx={{ backgroundColor: '#f9f9f9' }}>
                <Typography variant="h5" fontWeight={700}>
                    {t('questionnaires.answered')}
                </Typography>
                <Box
                    sx={{
                        height: 3,
                        width: 193,
                        backgroundColor: '#1976d2',
                        borderRadius: 2,
                        mb: 2
                    }}
                />
                <QuestionnaireAnswersTable
                    data={questionnaireAnswers}
                    isLoading={qaLoading}
                    count={qaTotalCount}
                    paginationModel={qaPaginationModel}
                    setPaginationModel={setQaPaginationModel}
                    rowsPerPageOptions={qaRowsPerPageOptions}
                />
            </CardContent>
        </Card>
    );
}
